import * as React from 'react';
import { LoadingCircle } from './loading-circle.component';
import { Markdown } from '../localization/markdown-wrapper';

export interface ISimpleLoadingDialogProps {
    title: string;
    message: string;
}

export default class SimpleLoadingDialog extends React.PureComponent<ISimpleLoadingDialogProps> {
    constructor(props: ISimpleLoadingDialogProps) {
        super(props);
    }

    public render() {
        return (
            <div className="small-popup-dialog-root loading-dialog-root">
                <div className="title primary-style">
                    <h3><Markdown text={this.props.title} /></h3>
                </div>
                <div className="content-container">
                    <div className="content">
                        <span><Markdown text={this.props.message} /></span>
                    </div>
                    <br />
                    <LoadingCircle />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/components/simple-loading.dialog.tsx